import React from "react";
import { Box, Grid, Typography, Avatar, Divider, List, ListItem, ListItemText, Stack } from "@mui/material";
import { Phone, Email, LocationOn, School, Stars, Person, Build } from "@mui/icons-material";

const Resume33 = ({
  color = "#4b2c4d", // Deep Purple theme
  font = "Roboto, sans-serif",
  fontSize = "12px",
  headingSize = "18px",
  pageSize = "A4",
}) => {
  return (
    <Box sx={{ 
             width: {lg:"210mm",xs:"170mm"},
 minHeight: "297mm", mx: "auto", bgcolor: "#fff", fontFamily: font,
      boxShadow: "0 0 10px rgba(0,0,0,0.1)", p: "20mm" 
    }}>
      {/* Header Section: Banner on the Right Side Only */}
      <Grid container alignItems="center" sx={{ mb: 4 }}>
        <Grid item xs={4}>
          {/* Optional: Placeholder for logo or kept empty as per your request */}
        </Grid>
        <Grid item xs={8} sx={{ 
          bgcolor: color, 
          p: 4, 
          color: "white",
          textAlign: "center" // Content aligned to right
        }}>
          <Typography variant="h3" sx={{ fontWeight: "900", letterSpacing: 2 }}>
            KORINA VILLANUEVA
          </Typography>
          <Typography variant="h6" sx={{ letterSpacing: 3, opacity: 0.9 }}>
            COMPUTER SCIENCE STUDENT
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        {/* Left Sidebar (33% width) */}
        <Grid item xs={4} sx={{ borderRight: "1px solid #eee" }}>
          <Typography sx={{ fontWeight: "bold", color: color, mb: 2, fontSize: headingSize }}>CONTACT</Typography>
          <Stack spacing={1.5} sx={{ mb: 4 }}>
            <Box display="flex" alignItems="center">
              <Phone sx={{ fontSize: 16, color, mr: 1 }} />
              <Typography sx={{ fontSize }}>+123-456-7890</Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <Email sx={{ fontSize: 16, color, mr: 1 }} />
              <Typography sx={{ fontSize }}>hello@reallygreatsite.com</Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <LocationOn sx={{ fontSize: 16, color, mr: 1 }} />
              <Typography sx={{ fontSize }}>123 Anywhere St., Any City</Typography>
            </Box>
          </Stack>

          <Divider sx={{ mb: 3 }} />

          <Typography sx={{ fontWeight: "bold", color: color, mb: 2 }}>SOFT SKILLS</Typography>
          <List dense sx={{ mb: 3 }}>
            {["Teamwork", "Time Management", "Leadership", "Critical Thinking"].map(s => (
              <ListItem key={s} disablePadding sx={{ py: 0.5 }}>
                <Typography sx={{ fontSize }}>• {s}</Typography>
              </ListItem>
            ))}
          </List>

          <Typography sx={{ fontWeight: "bold", color: color, mb: 2 }}>TECH SKILLS</Typography>
          <Box sx={{ "& p": { fontSize: "11px", mb: 0.8 } }}>
            <p>Python (Expert)</p>
            <p>Java (Expert)</p>
            <p>SQL / MySQL</p>
            <p>Machine Learning</p>
            <p>Web Development</p>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Typography sx={{ fontWeight: "bold", color: color, mb: 2 }}>LANGUAGES</Typography>
          <Typography sx={{ fontSize }}>English (Fluent)</Typography>
          <Typography sx={{ fontSize }}>French (Fluent)</Typography>
        </Grid>

        {/* Right Main Content (66% width) */}
        <Grid item xs={8} sx={{width:{lg:"400px",xs:"400px"}}}>
          <Box sx={{ mb: 4 }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
              <Person sx={{ color }} />
              <Typography sx={{ fontWeight: "bold", color: color, fontSize: headingSize }}>PROFILE</Typography>
            </Stack>
            <Typography sx={{ fontSize, color: "#555", lineHeight: 1.6 }}>
              Highly motivated Computer Science student with a strong foundation in software development and data analysis. Experienced in building scalable web applications and implementing machine learning algorithms.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
              <School sx={{ color }} />
              <Typography sx={{ fontWeight: "bold", color: color, fontSize: headingSize }}>EDUCATION</Typography>
            </Stack>
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ fontWeight: "bold", display: "flex", justifyContent: "space-between" }}>
                Bachelor of Computer Science <span>2029 - 2033</span>
              </Typography>
              <Typography variant="caption" color="gray">Wardiere University | GPA: 3.8 / 4.0</Typography>
            </Box>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
              <Build sx={{ color }} />
              <Typography sx={{ fontWeight: "bold", color: color, fontSize: headingSize }}>PROJECTS</Typography>
            </Stack>
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ fontWeight: "bold" }}>E-commerce Platform Development</Typography>
              <Typography sx={{ fontSize, mb: 0.5 }}>Full-stack development using React and Node.js with secure payment integration.</Typography>
              <Typography variant="caption" sx={{ color, fontWeight: "bold" }}>Tech: React, Node.js, MongoDB</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontWeight: "bold" }}>Real-time Chat Application</Typography>
              <Typography sx={{ fontSize }}>End-to-end encrypted messaging service using Socket.io and Express.</Typography>
            </Box>
          </Box>

          <Box>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
              <Stars sx={{ color }} />
              <Typography sx={{ fontWeight: "bold", color: color, fontSize: headingSize }}>ACHIEVEMENTS</Typography>
            </Stack>
            <Typography sx={{ fontSize, mb: 1 }}>• Ranked top 5% in Global Machine Learning Hackathon 2031.</Typography>
            <Typography sx={{ fontSize }}>• Recipient of the Academic Excellence Scholarship (2029-2033).</Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Resume33;

export const resumeMeta = {
  hasPhoto: false, // Changed to false as requested
  columns: 2,
  colorOptions: [
    { value: '#4b2c4d', label: 'Purple' },
    { value: '#2196f3', label: 'Blue' },
    { value: '#4caf50', label: 'Green' },
    { value: '#ff9800', label: 'Orange' },
    { value: '#f44336', label: 'Red' }
  ]
};